/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import { type JSX, splitProps } from 'solid-js'

export type IconWeight = 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone'

export interface IconProps extends JSX.SvgSVGAttributes<SVGSVGElement> {
  size?: number | string
  color?: string
  weight?: IconWeight
  mirrored?: boolean
}

export type WeightRenderers = Partial<Record<IconWeight, (color: string) => JSX.Element>>

export function IconBase(allProps: IconProps & { renderers: WeightRenderers }) {
  const [props, rest] = splitProps(allProps, ['size', 'color', 'weight', 'mirrored', 'renderers'])
  const color = () => props.color ?? 'currentColor'
  const size = () => props.size ?? '1em'
  // Weight resolves inside JSX so dynamic weights (e.g. rating stars) stay
  // reactive; ungenerated weights fall back to 'regular' instead of blanking.
  const paths = () => {
    const weight = props.weight ?? 'regular'
    const renderer = props.renderers[weight] ?? props.renderers.regular
    if (import.meta.env.DEV && !props.renderers[weight]) {
      console.error(
        `phosphor icon: weight "${weight}" not generated, falling back to regular. Re-run scripts/generate-phosphor-icons.mjs.`
      )
    }
    return renderer ? renderer(color()) : null
  }
  // mirrored uses a CSS transform (Solid's svg types have no transform attr);
  // rest spreads after it so a callsite style always wins
  const mirrorStyle = () => (props.mirrored ? { transform: 'scale(-1, 1)' } : {})
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size()}
      height={size()}
      fill={color()}
      viewBox="0 0 256 256"
      style={mirrorStyle()}
      {...rest}
    >
      <rect width="256" height="256" fill="none" />
      {paths()}
    </svg>
  )
}
